export const openPdfUrlWithLoader = (
  pdfUrl: string,
  title = 'PDF loading, please wait...'
) => {
  const win = window.open('', '_blank');

  if (!win) {
    window.location.href = pdfUrl;
    return;
  }

  win.document.write(`
    <html>
      <head>
        <title>${title}</title>
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <style>
          .full-page-loader {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(255, 255, 255, 0.85);
            display: flex;
            justify-content: center;
            align-items: center;
            z-index: 9999;
          }

          .loader-content {
            text-align: center;
          }

          .spinner {
            width: 60px;
            height: 60px;
            border: 6px solid #ddd;
            border-top: 6px solid #00384f;
            border-radius: 50%;
            animation: spin 0.9s linear infinite;
            margin: 0 auto;
          }

          .loading-text {
            margin-top: 12px;
            font-size: 18px;
            font-weight: 500;
            color: #333;
            letter-spacing: 1px;
          }

          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }

          body {
            margin: 0;
            font-family: Arial, sans-serif;
          }
        </style>
      </head>
      <body>
        <div class="full-page-loader">
          <div class="loader-content">
            <div class="spinner"></div>
            <div class="loading-text">${title}</div>
          </div>
        </div>
      </body>
    </html>
  `);

  win.document.close();

  // small delay so loader is visible before redirect
  setTimeout(() => {
    win.location.href = pdfUrl;
  }, 100);
};